import React from "react";
import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";

export const ExternalLinkIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue89e'}</MuiIcon>
    );
}
